module.exports = __webpack_public_path__ + "static/media/OrdemServico4.565063a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrdemServicos/OrdemServico4.png
// module id = 1767
// module chunks = 0